import { render, staticRenderFns } from "./edit_number.vue?vue&type=template&id=190c9f4e&scoped=true&"
import script from "./edit_number.vue?vue&type=script&lang=js&"
export * from "./edit_number.vue?vue&type=script&lang=js&"
import style0 from "./edit_number.vue?vue&type=style&index=0&id=190c9f4e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190c9f4e",
  null
  
)

export default component.exports